export const SET_FILTERS = 'SET_FILTERS';
export const UPDATE_PAGINATOR = 'UPDATE_PAGINATOR';
export const UPDATE_RESULTS = 'UPDATE_RESULTS';
export const CHANGE_SORT_CRITERIA = 'CHANGE_SORT_CRITERIA';
export const UPDATE_ACTIVE_FILTERS = 'UPDATE_ACTIVE_FILTERS';
export const SET_LISTING_HEIGHT = 'SET_LISTING_HEIGHT';
export const SET_PROCESSING_STATE = 'SET_PROCESSING_STATE';
